import { withTheme } from '@emotion/react';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import compose from 'utils/compose';

import { chartOfAccountsSelectors, chartOfAccountsUtils } from 'app-components/flux/chart-of-accounts';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import QTip from 'components/QuickenControls/QTip';

import { getFilteredChartOfAccountList } from './selectors';

import { withStyles } from 'tss-react/mui';
import CategoryFieldEditable from './CategoryFieldEditable';

const styles = (theme) => ({
  invalidText: {
    color: theme.palette.error.main,
    '& .MuiTextField-root, .MuiFilledInput-root': {
      borderColor: theme.palette.error.main,
    },
  },
});

class CategoryField extends PureComponent {
  constructor(props) {
    super(props);

    const coaId = chartOfAccountsUtils.getCoaId(props.value, props.allowBlank); // allow blank
    const coaNode = this.getCoaNode(coaId, props); // props.coaNodesById ? props.coaNodesById.get(coaId) : null;

    this.state = {
      tfValue: coaId === 'BLANK' ? '' : this.getDisplayName(coaNode),
      isTransfer: this.isTransfer(coaNode),
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.coaNodesById) {
      if (
        nextProps.value !== this.props.value ||
        nextProps.coaNodesById !== this.props.coaNodesById ||
        nextProps.longCats !== this.props.longCats
      ) {
        const coaId = chartOfAccountsUtils.getCoaId(nextProps.value, nextProps.allowBlank);
        const coaNode = this.getCoaNode(coaId, nextProps); // (coaId === 'BLANK' ? '' : nextProps.coaNodesById.get(coaId)); // allowBlank
        // todo: if coaNode cannot be found, set it to uncategorized coaNode
        if (coaNode) {
          this.setState({ isTransfer: this.isTransfer(coaNode), tfValue: this.getDisplayName(coaNode, nextProps) });
        } else {
          this.setState({ isTransfer: false, tfValue: '' });
        }
      }
    }
  }

  getCoaNode = (coaId, props) => {
    let ret = props.coaNodesById ? props.coaNodesById.get(coaId) : null;

    if (chartOfAccountsUtils.isTransferCoaNotFound(props.value)) {
      ret = props.coaNodesById.get(chartOfAccountsUtils.TRANSFER_NOT_FOUND_COA_ID);
    }
    return ret;
  };

  getDisplayName = (node, props = this.props) => {
    if (node) {
      return props.longCats ? node.fullPathName : node.name;
    }
    return '[N/A]';
  };

  isTransfer = (node) => node && node.coa.type === 'ACCOUNT';

  makeTransferName = (val) => `''${val}''`;

  render() {
    const {
      classes,
      isRequired,
      editable,
      clickable,
      classNameWhenNotEditable,
      variant,
      disableTooltip,
      name,
      noWrap,
      tooltipProps = [],
    } = this.props;
    const toolTipTitle = this.state.isTransfer ? this.makeTransferName(this.state.tfValue) : this.state.tfValue;

    const Wrap = disableTooltip ? React.Fragment : QTip;
    const wrapProps = disableTooltip
      ? {}
      : { wrapOnly: true, title: this.props.tooltip ? toolTipTitle : null, ...tooltipProps };

    return (
      <>
        {editable && (
          <Box display={'flex'} flex={1} flexDirection={'column'} className={isRequired ? classes.invalidText : ''}>
            <CategoryFieldEditable
              sharedcomponentid='CategoryFieldEditable'
              className={this.props.className}
              sx={this.props.sx}
              {...this.props}
            />
            {isRequired && (
              <Typography variant='captionRegular' className={classes.invalidText}>
                Required
              </Typography>
            )}
          </Box>
        )}

        {!editable && (
          <Wrap {...wrapProps}>
            <Typography
              sharedcomponentid='CategoryFieldEditable'
              variant={variant}
              clickable={clickable}
              className={classNameWhenNotEditable}
              name={name}
              noWrap={noWrap}
            >
              {this.state.isTransfer ? this.makeTransferName(this.state.tfValue) : this.state.tfValue}
            </Typography>
          </Wrap>
        )}
      </>
    );
  }
}

export const CategoryFieldPropTypes = {
  // props from parent
  classes: PropTypes.object,
  isRequired: PropTypes.bool,
  variant: PropTypes.string,
  editable: PropTypes.bool,
  value: PropTypes.object,
  name: PropTypes.string,
  className: PropTypes.string,
  clickable: PropTypes.bool,
  returnSelectionMethod: PropTypes.bool,
  longCats: PropTypes.bool,
  allowBlank: PropTypes.bool,
  depth: PropTypes.number,
  classNameWhenNotEditable: PropTypes.string,
  tooltip: PropTypes.bool, // show a tooltip on static value?
  tooltipProps: PropTypes.object,
  fontSize: PropTypes.string,
  filterFn: PropTypes.func,
  disableTooltip: PropTypes.bool,
  noWrap: PropTypes.bool,
  sx: PropTypes.object,

  theme: PropTypes.object,

  // props from redux
  coaNodesById: PropTypes.object,
  filteredCOAList: PropTypes.array,
  disabled: PropTypes.bool,
};
CategoryField.propTypes = CategoryFieldPropTypes;

CategoryField.defaultProps = {
  variant: 'body2',
  disableTooltip: false,
};

function mapStateToProps(state, ownProps) {
  return {
    coaNodesById: chartOfAccountsSelectors.getChartOfAccountNodesById(state, ownProps),
    filteredCOAList: getFilteredChartOfAccountList(state, ownProps),
  };
}

// TODO: Move to functional component to prevent mapStateToProps from running on parent re-render

// note: order-matters - props flow from top to bottom
export default compose(withTheme)(connect(mapStateToProps)(withStyles(CategoryField, styles)));
